<script>
	import { Router, Link, link, Route } from "svelte-routing";
	import { onMount, tick } from 'svelte';

	function login() {
		navigate("/dashboard");
	}

</script>

<link rel="stylesheet" href="/main/assets/css/dashforge.auth.css">
<header class="navbar navbar-header navbar-header-fixed">
	<a use:link href="/" id="mainMenuOpen" class="burger-menu"><i data-feather="menu"></i></a>
	<div class="navbar-brand">
		<a use:link href="/" class="df-logo">quick<span>class</span></a>
	</div><!-- navbar-brand -->
	<div id="navbarMenu" class="navbar-menu-wrapper">
		<div class="navbar-menu-header">
			<a use:link href="/" class="df-logo">quick<span>class</span></a>
			<a use:link id="mainMenuClose" href="/"><i data-feather="x"></i></a>
		</div><!-- navbar-menu-header -->
		<ul class="nav navbar-menu">
			<li class="nav-label pd-l-20 pd-lg-l-25 d-lg-none">Main Navigation</li>
			<li class="nav-item">
				<a use:link href="/" class="nav-link"><i data-feather="pie-chart"></i> Home</a>
			</li>
			<li class="nav-item">
				<a use:link href="/" class="nav-link"><i data-feather="layers"></i> About Us</a>
			</li>
			<li class="nav-item">
				<a use:link href="/" class="nav-link"><i data-feather="package"></i> Features</a>
			</li>
			<li class="nav-item">
				<a use:link href="/" class="nav-link"><i data-feather="box"></i> Pricing</a>
			</li>
			<li class="nav-item">
				<a use:link href="/" class="nav-link"><i data-feather="archive"></i>
					Contact Us</a>
			</li>
		</ul>
	</div><!-- navbar-menu-wrapper -->
	<div class="navbar-right">
		<a use:link href="/" class="btn btn-social"><i class="fab fa-facebook"></i></a>
		<a use:link href="/" class="btn btn-social"><i class="fab fa-instagram"></i></a>
		<a use:link href="/" class="btn btn-social"><i class="fab fa-twitter"></i></a>
		<a use:link href="/login" class="btn btn-buy"><i data-feather="shopping-bag"></i> <span>Login</span></a>
		<!-- <a use:link href="/signup" class="btn btn-buy"><i data-feather="shopping-bag"></i> <span>Register</span></a> -->
	</div><!-- navbar-right -->
</header><!-- navbar -->

<div class="content content-fixed content-auth" style="flex: 1;">
	<div class="container">
		<div class="home-slider">
			<div class="home-lead">
				<div class="df-logo-initial mg-b-15">
					<p>qc</p>
				</div>
				<p class="home-text">Manage classes online</p>
		
				<h6 class="home-headline">Make your institute management app more professional with this <span>super awesome</span> and
					Quick Classes app.</h6>
		
				<div class="d-flex wd-lg-350">
					<!-- <a use:link href="/signup" class="btn btn-brand-01 btn-uppercase flex-fill">Register Now</a> -->
					<a use:link href="/login" class="btn btn-white btn-uppercase flex-fill mg-l-10">Login</a>
				</div>
		
				<div class="d-flex tx-20 mg-t-40">
					<div class="tx-purple"><i class="fab fa-bootstrap"></i></div>
					<div class="tx-orange pd-l-10"><i class="fab fa-html5"></i></div>
					<div class="tx-primary pd-l-10"><i class="fab fa-css3-alt"></i></div>
					<div class="tx-pink pd-l-10"><i class="fab fa-sass"></i></div>
					<div class="tx-warning pd-l-10"><i class="fab fa-js"></i></div>
					<div class="tx-danger pd-l-10"><i class="fab fa-npm"></i></div>
					<div class="tx-danger pd-l-10"><i class="fab fa-gulp"></i></div>
					<div class="bd-l mg-l-10 mg-sm-l-20 pd-l-10 pd-sm-l-20"></div>
					<div class="tx-color-03" data-toggle="tooltip" data-title="Ongoing development" data-original-title=""
						title=""><i class="fab fa-angular"></i></div>
					<div class="tx-color-03 pd-l-10" data-toggle="tooltip" data-title="Coming soon" data-original-title=""
						title=""><i class="fab fa-react"></i></div>
					<div class="tx-color-03 pd-l-10" data-toggle="tooltip" data-title="Coming soon" data-original-title=""
						title=""><i class="fab fa-vuejs"></i></div>
				</div>
		
				<div class="tx-12 mg-t-40">
					<a use:link href="/" class="link-03">Doc<span class="d-none d-sm-inline">Documentation</span><span
							class="d-sm-none">s</span></a>
					<a use:link href="/" class="link-03 mg-l-10 mg-sm-l-20">Changelog</a>
					<a use:link href="/"
						class="link-03 mg-l-10 mg-sm-l-20">Licenses</a>
					<a use:link href="/"
						class="link-03 mg-l-10 mg-sm-l-20">Refund Policy</a>
				</div>
			</div>
			<div class="home-slider-img">
				<div><img src="assets/img/home-1.png" alt=""></div>
				<div><img src="assets/img/home-2.png" alt=""></div>
				<div><img src="assets/img/home-2-dark.png" alt=""></div>
			</div>
			<div class="home-slider-bg-one"></div>
		</div>
	</div><!-- container -->
</div><!-- content -->

<footer class="footer">
	<div>
		<span>&copy; 2023. QuickClasses V2.3 </span>
		<span>By <a href="https://sdlccorp.com/">SDLC Corp.</a></span>
	</div>
	<div>
		<nav class="nav">
			<a use:link href="/" class="nav-link">Licenses</a>
			<a use:link href="/" class="nav-link">Change Log</a>
			<a use:link href="/" class="nav-link">Get Help</a>
		</nav>
	</div>
</footer>